// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DeccoUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.mjs";
import * as PnmIntShiftReqBasicDetailsApiModel$PorterinFeature from "../../api-model/PnmIntShiftReqBasicDetailsApiModel.mjs";

function apiModelToState(model) {
  return {
          sr_external_id: model.sr_external_id
        };
}

function execute(json) {
  var model = DeccoUtils$Catalyst.resolveResult(PnmIntShiftReqBasicDetailsApiModel$PorterinFeature.t_decode(json), "PnmIntShiftReqBasicDetailsEntityMapper.res");
  return {
          sr_external_id: model.sr_external_id
        };
}

export {
  apiModelToState ,
  execute ,
}
/* DeccoUtils-Catalyst Not a pure module */
